/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Metadata = {
  properties: {
    pagination: {
      type: 'PaginationMetadata',
      isRequired: true,
    },
  },
} as const;
